module.exports = __webpack_public_path__ + "static/media/RykerWhite.3bf8f80d.jpg";